'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useAppDispatch } from '@/store/hooks';
import { eventoRegistrado } from '../store/slice';
import type { RecursoPesquisa } from '../types/pesquisaSatisfacaoTypes';

/**
 * A API de uma linha para os pontos de contato. Chame no SUCESSO da ação — nunca
 * em tela de consulta e nunca em cima de erro (RN-09): o evento é "isto acabou de
 * acontecer", e disparar num carregamento de tela mediria a leitura, não a
 * experiência.
 *
 * O `recurso` é o que dá contexto à nota baixa no painel de CS. Passe-o sempre que
 * a ação tiver um sujeito — o lote, o caso, o processo.
 *
 * @example
 * const registrarEvento = useRegistrarEventoPesquisa();
 * registrarEvento('notificacao.lote.processado', { tipo: 'lote_notificacao', id: loteId });
 */
export function useRegistrarEventoPesquisa() {
  const $ = _c(2);
  const dispatch = useAppDispatch();
  let t0;
  if ($[0] !== dispatch) {
    t0 = (evento, t1) => {
      const recurso = t1 === undefined ? null : t1;
      dispatch(eventoRegistrado({
        evento,
        ocorridoEmIso: new Date().toISOString(),
        recurso
      }));
    };
    $[0] = dispatch;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}